import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { documentStore, layoutStore, useScreen } from "@/hooks";
import { FlexBox, IconButton, Separator } from "@/components/common";


/**
 * Displays buttons for going back and forward in the view history.
 */
const __default__ = {
  name: "ViewHistory",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

return (_ctx: any,_cache: any) => {
  return (_unref(layoutStore).mode !== 'tim' && !_unref(smallWindow))
    ? (_openBlock(), _createBlock(_unref(FlexBox), {
        key: 0,
        align: "center"
      }, {
        default: _withCtx(() => [
          (_unref(documentStore).hasPreviousHistory)
            ? (_openBlock(), _createBlock(_unref(IconButton), {
                key: 0,
                small: "",
                tooltip: "Previous View",
                icon: "back",
                color: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(documentStore).switchDocumentHistory('previous')))
              }))
            : _createCommentVNode("", true),
          (_unref(documentStore).hasNextHistory)
            ? (_openBlock(), _createBlock(_unref(IconButton), {
                key: 1,
                small: "",
                tooltip: "Next View",
                icon: "forward",
                color: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(documentStore).switchDocumentHistory('next')))
              }))
            : _createCommentVNode("", true),
          (_unref(documentStore).hasPreviousHistory || _unref(documentStore).hasNextHistory)
            ? (_openBlock(), _createBlock(_unref(Separator), {
                key: 2,
                vertical: "",
                inset: "",
                nav: "",
                x: "1"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})